import React, { useState, useEffect } from 'react';
import { Play, X, ChevronLeft, ChevronRight } from 'lucide-react';

const Gallery = () => {
  const [playingVideo, setPlayingVideo] = useState(null);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const featuredVideo = {
    id: 'featured',
    vimeoId: '990952601',
    thumbnail: 'https://vumbnail.com/990952601.jpg',
    title: 'IllumiDEL Signature Installation'
  };

  const supplementaryVideos = [
    {
      id: 'video1',
      videoType: 'mp4',
      videoUrl: 'https://customer-assets.emergentagent.com/job_holiday-lights-pro/artifacts/cmt01nxk_%E2%9C%A8%20IllumiDEL%20Tracks%20with%20COB%20%3D%20sleek%20design%20%2B%20flawless%20glow.%F0%9F%8E%AF%20Modern%20lighting%2C%20built%20to%20last.%23Il.mp4',
      thumbnail: 'https://customer-assets.emergentagent.com/job_holiday-lights-pro/artifacts/erwnvuqn_Instagram%20Video%20Downloader%20-%20Download%20Instagram%20Video%2C%20Photo%2C%20Profile.jpeg',
      title: 'IllumiDEL Tracks Showcase'
    },
    {
      id: 'video2',
      vimeoId: '943763882',
      thumbnail: 'https://vumbnail.com/943763882.jpg',
      title: 'Residential Installation'
    },
    {
      id: 'video3',
      vimeoId: '1103282060',
      thumbnail: 'https://vumbnail.com/1103282060.jpg',
      title: 'Animation Effects Demo'
    }
  ];

  const galleryImages = [
    {
      id: 'img1',
      src: 'https://customer-assets.emergentagent.com/job_holiday-lights-pro/artifacts/l01wzac3_1.1.webp',
      alt: 'Permanent Lighting Installation 1'
    },
    {
      id: 'img2',
      src: 'https://customer-assets.emergentagent.com/job_holiday-lights-pro/artifacts/qefdw8jy_1.2.webp',
      alt: 'Permanent Lighting Installation 2'
    },
    {
      id: 'img3',
      src: 'https://customer-assets.emergentagent.com/job_holiday-lights-pro/artifacts/6v4iczq9_1.3.webp',
      alt: 'Permanent Lighting Installation 3'
    },
    {
      id: 'img4',
      src: 'https://customer-assets.emergentagent.com/job_holiday-lights-pro/artifacts/9msu0d7c_1.4.webp',
      alt: 'Permanent Lighting Installation 4'
    },
    {
      id: 'img5',
      src: 'https://customer-assets.emergentagent.com/job_holiday-lights-pro/artifacts/3j2op5ox_1.5.webp',
      alt: 'Permanent Lighting Installation 5'
    },
    {
      id: 'img6',
      src: 'https://customer-assets.emergentagent.com/job_holiday-lights-pro/artifacts/de89ndf3_IMG_3645.JPEG',
      alt: 'Permanent Lighting Installation 6'
    },
    {
      id: 'img7',
      src: 'https://customer-assets.emergentagent.com/job_holiday-lights-pro/artifacts/exnpcw6l_1.7.webp',
      alt: 'Permanent Lighting Installation 7'
    },
    {
      id: 'img8',
      src: 'https://customer-assets.emergentagent.com/job_holiday-lights-pro/artifacts/1h6kfi46_1.8.webp',
      alt: 'Permanent Lighting Installation 8'
    },
    {
      id: 'img9',
      src: 'https://customer-assets.emergentagent.com/job_holiday-lights-pro/artifacts/zvnzx988_1.91.webp',
      alt: 'Permanent Lighting Installation 9'
    },
    {
      id: 'img10',
      src: 'https://customer-assets.emergentagent.com/job_holiday-lights-pro/artifacts/zdk5aqqe_1.92.webp',
      alt: 'Permanent Lighting Installation 10'
    },
    {
      id: 'img11',
      src: 'https://customer-assets.emergentagent.com/job_holiday-lights-pro/artifacts/37quqorv_480157538_664118736133897_2485922308875956844_n.jpg',
      alt: 'Permanent Lighting Installation 11'
    },
    {
      id: 'img12',
      src: 'https://customer-assets.emergentagent.com/job_holiday-lights-pro/artifacts/gtnm1y69_480278766_664118436133927_6099613598520223069_n.jpg',
      alt: 'Permanent Lighting Installation 12'
    },
    {
      id: 'img13',
      src: 'https://customer-assets.emergentagent.com/job_holiday-lights-pro/artifacts/bhk2zy93_482052398_680807187798385_4971114944707719737_n.jpg',
      alt: 'Permanent Lighting Installation 13'
    },
    {
      id: 'img14',
      src: 'https://customer-assets.emergentagent.com/job_holiday-lights-pro/artifacts/hixe5ah5_482224646_680807304465040_3188358540127725233_n.jpg',
      alt: 'Permanent Lighting Installation 14'
    },
    {
      id: 'img15',
      src: 'https://customer-assets.emergentagent.com/job_holiday-lights-pro/artifacts/6klwn3ya_commercial_canopywrap_g30_2-.jpg',
      alt: 'Commercial Canopy Wrap Installation'
    }
  ];

  const openLightbox = (index) => {
    setCurrentImageIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
  };

  const goToPrevious = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === 0 ? galleryImages.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === galleryImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!lightboxOpen) return;
      
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') goToPrevious();
      if (e.key === 'ArrowRight') goToNext();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [lightboxOpen]);

  const VideoPlayer = ({ video, isFeatured }) => (
    <div className={`relative group ${isFeatured ? 'aspect-video' : 'aspect-video'}`}>
      {playingVideo === video.id ? (
        video.videoType === 'mp4' ? (
          <video
            src={video.videoUrl}
            className="w-full h-full rounded-lg object-cover"
            controls
            autoPlay
          />
        ) : (
          <iframe
            src={`https://player.vimeo.com/video/${video.vimeoId}?autoplay=1`}
            className="w-full h-full rounded-lg"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            title={video.title}
          ></iframe>
        )
      ) : (
        <>
          <img
            src={video.thumbnail}
            alt={video.title}
            className="w-full h-full object-cover rounded-lg"
          />
          <div className="absolute inset-0 bg-black/40 group-hover:bg-black/60 transition-colors duration-300 rounded-lg flex items-center justify-center">
            <button
              onClick={() => setPlayingVideo(video.id)}
              className="w-16 h-16 bg-blue-500 hover:bg-blue-600 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
            >
              <Play className="text-white ml-1" size={28} fill="currentColor" />
            </button>
          </div>
          <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/80 to-transparent rounded-b-lg">
            <h3 className="text-white font-semibold">{video.title}</h3>
          </div>
        </>
      )}
    </div>
  );

  return (
    <section id="gallery" className="py-24 bg-gray-900">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">Gallery</h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            See our stunning installations in action
          </p>
        </div>

        {/* Featured Video */}
        <div className="mb-12">
          <VideoPlayer video={featuredVideo} isFeatured={true} />
        </div>

        {/* Supplementary Videos */}
        <div className="grid md:grid-cols-3 gap-6 mb-16">
          {supplementaryVideos.map((video) => (
            <VideoPlayer key={video.id} video={video} isFeatured={false} />
          ))}
        </div>

        {/* Gallery Images */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {galleryImages.map((image, index) => (
            <div 
              key={image.id} 
              className="relative group overflow-hidden rounded-lg aspect-square cursor-pointer"
              onClick={() => openLightbox(index)}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300"></div>
            </div>
          ))}
        </div>

        {/* Lightbox Modal */}
        {lightboxOpen && (
          <div className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center">
            {/* Close Button */}
            <button
              onClick={closeLightbox}
              className="absolute top-4 right-4 text-white hover:text-blue-400 transition-colors z-50"
            >
              <X size={40} />
            </button>

            {/* Previous Button */}
            <button
              onClick={goToPrevious}
              className="absolute left-4 text-white hover:text-blue-400 transition-colors z-50"
            >
              <ChevronLeft size={60} />
            </button>

            {/* Image */}
            <div className="max-w-7xl max-h-[90vh] mx-auto px-16">
              <img
                src={galleryImages[currentImageIndex].src}
                alt={galleryImages[currentImageIndex].alt}
                className="max-w-full max-h-[90vh] object-contain"
              />
              <p className="text-white text-center mt-4 text-lg">
                {currentImageIndex + 1} / {galleryImages.length}
              </p>
            </div>

            {/* Next Button */}
            <button
              onClick={goToNext}
              className="absolute right-4 text-white hover:text-blue-400 transition-colors z-50"
            >
              <ChevronRight size={60} />
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Gallery;
